import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a77741e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grade-percent" }
const _hoisted_2 = { class: "grade-percent__img-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "grade-percent__img grade-percent__img--current",
  src: "https://object.pscloud.io/loyalty/grading-front/tick-orange.svg",
  alt: "tick-orange"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "grade-percent__img grade-percent__img--prev",
  src: "https://object.pscloud.io/loyalty/grading-front/tick-gray.svg",
  alt: "tick-gray"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "grade-percent__img grade-percent__img--lock",
  src: "https://object.pscloud.io/loyalty/grading-front/lock.svg",
  alt: "lock"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "grade-percent__img grade-percent__img--current-saved",
  src: "https://object.pscloud.io/loyalty/grading-front/save-icon.svg",
  alt: "save-icon"
}, null, -1))
const _hoisted_7 = { class: "grade-percent__amount" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_circle_progress = _resolveComponent("circle-progress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_circle_progress, {
        percent: _ctx.currentPercent,
        "fill-color": "#FF511B",
        "empty-color": "#D4D3DF",
        viewport: true,
        transition: 2000,
        class: "grade-percent__img--next",
        style: {"height":"20px","width":"20px"}
      }, null, 8, ["percent"]),
      _hoisted_5,
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.gradePercent) + "%", 1)
  ]))
}